<template>
  <div id="app">
    <router-view></router-view>
  </div>
</template>

<script>
export default {
  name: "App",
};
</script>

<style>
html,
body,
#app {
  width: 100%;
  height: 100%;
}
body {
  margin: 0px;
}
*{
	margin: 0;
	padding: 0;
}
a {
  text-decoration: none;
}
a:link {
  color: #9f9f9f;
}
a:visited {
  color: #9f9f9f;
}
a:hover {
  color: #9f9f9f;
}
a:active {
  color: #9f9f9f;
}

/*  */
input:focus{
  outline: none;
}
.clear{
	clear: both;
}
li{
	list-style: none;
}
.el-tabs__item.is-active{
	color: #0A0A0A;
}
.el-tabs__item:hover{
	color: #0A0A0A;
}
.el-tabs__active-bar{
	background-color: #0A0A0A;
}
#app {
  font-family: Avenir, Helvetica, Arial, sans-serif;
  -webkit-font-smoothing: antialiased;
  -moz-osx-font-smoothing: grayscale;
  color: #2c3e50;
  /* margin-top: 60px; */
  background: #FFFFFF;
}
</style>
